import React from 'react';
import { Link } from 'react-router-dom';

import SummaryGridField from 'components/atoms/summary_grid_field';
import { NAO_INFORMADO } from 'components/molecules/bidding_summary_constants';
import {
  getCriteriosPropostaRows,
  shouldShowProgramaIntegridadeButton,
} from 'components/molecules/bidding_summary_utils';

import type { BiddingSummaryData } from 'store/modules/bidding_summary_store/types';

interface BiddingSummaryCriteriosPropostaProps {
  summary: BiddingSummaryData;
}

const BiddingSummaryCriteriosProposta: React.FC<BiddingSummaryCriteriosPropostaProps> = ({
  summary,
}) => {
  const rows = getCriteriosPropostaRows(summary);
  const leftRows = rows.filter((row) =>
    ['Validade da proposta', 'Critérios de desempate'].includes(row.label),
  );
  const rightRows = rows.filter((row) => row.label === 'Exigências da proposta comercial');
  const programaIntegridade = summary.programa_integridade?.trim() || NAO_INFORMADO;
  const showProgramaIntegridadeButton = shouldShowProgramaIntegridadeButton(
    summary.programa_integridade,
  );

  return (
    <div className="row">
      <div className="col-md-6">
        {leftRows.map((row) => (
          <SummaryGridField key={row.label} label={row.label} value={row.value} />
        ))}
      </div>
      <div className="col-md-6">
        {rightRows.map((row) => (
          <SummaryGridField key={row.label} label={row.label} value={row.value} />
        ))}
        {showProgramaIntegridadeButton ? (
          <div className="mb-3">
            <div className="text-muted summary-field-label mb-2">Programa de Integridade</div>
            <div className="d-flex align-items-center flex-wrap summary-field-value">
              <span className="font-weight-medium text-dark mr-2 mb-1">{programaIntegridade}</span>
              <Link
                to="/programa_de_integridade"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-outline-primary btn-sm summary-programa-integridade-btn"
                aria-label="Abrir formulário do Programa de Integridade em nova aba"
              >
                Programa de Integridade
              </Link>
            </div>
          </div>
        ) : (
          <SummaryGridField label="Programa de Integridade" value={programaIntegridade} />
        )}
      </div>
    </div>
  );
};

export default BiddingSummaryCriteriosProposta;
